import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_ERROR_I18N_COMPONENT_KEY } from "./constants";
var localesPt = /*#__PURE__*/_defineProperty({}, PAGE_ERROR_I18N_COMPONENT_KEY, {
  ALT_ERROR_IMAGE: 'Ilustração do erro {{errorCode}}',
  TITLE_ERROR: 'Erro',
  LABEL_ERROR_CODE: 'Código de erro {{errorCode}}',
  LABEL_LOGO_CREHANA: 'Logo de Crehana',
  WHAT_WENT_WRONG: 'O que deu errado?',
  CTA_DEFAULT_TEXT: 'Ir para o início',
  CTA_DEFAULT_TEXT_401: 'Entrar',
  NO_PERMISSIONS_401_TITLE: 'Ops! você não pode acessar esta seção',
  NO_PERMISSIONS_403_TITLE: 'Desculpe! Não podemos mostrar esta informação',
  NO_PERMISSIONS_500_TITLE: 'Ops! Isso não estava em nossos planos',
  CONTACT_ADMIN: 'Se o problema persistir, entre em contato com o administrador da sua conta. Enquanto isso, você pode:',
  WHAT_HAPPENED_ERROR__401_DESCRIPTION: 'Você não tem as credenciais necessárias para acessar. Por favor, verifique se você iniciou a sessão corretamente ou entre com uma conta autorizada.',
  WHAT_HAPPENED_ERROR__403_DESCRIPTION: 'Você não tem função e permissões suficientes para acessar esta informação.',
  WHAT_HAPPENED_ERROR__500_DESCRIPTION: 'Encontramos um problema técnico. Estamos trabalhando para solucioná-lo o mais rápido possível.',
  LABEL_POWERED_BY_CREHANA: 'Powered by Crehana',
  TITLE_401: 'Sua sessão expirou',
  DESCRIPTION_401: 'ou não pudemos confirmar suas credenciais de acesso'
});
export default localesPt;